const arrayGroupBy = (array?: any[], key?: string) => {
  if (!array || !key) {
    return {};
  }
  return array.reduce((group: {[key: string]: any[]}, item: any) => {
    group[item[key]] = group[item[key]] ?? [];
    group[item[key]].push(item);

    return group;
  }, {});
};

export default arrayGroupBy;
